var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-apply-cancel',{attrs:{"standalone":_vm.overlayTrackStandAlone},on:{"cancel":_vm.cancel,"apply":_vm.applyClick}})}
var staticRenderFns = []

export { render, staticRenderFns }